import { css } from 'lit';
export const button = css `
  :host {
    --button-size-small: 2.25rem; /* 36px */
    --button-size-medium: 2.688rem; /* 43px */
    --button-padding-xs: 0.438rem; /* 7px */
    --button-padding-sm: 0.938rem; /* 15px */
    --button-padding-md: 1.125rem; /* 18px */

    display: inline-block;
  }

  .button {
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    font-family: var(--font-family-monument);
    font-size: var(--font-size-sm);
    border-radius: 999px; /* gives a border radius that is half the height of the button */

    height: var(--button-size-medium);
    min-width: 6.938rem;
    width: 100%;
    padding-left: var(--button-padding-md);
    padding-right: var(--button-padding-md);

    background-color: var(--color-neutral);
    color: var(--neutral-contrast-color);
    text-decoration: none;
    transition: background-color 150ms;
  }

  .button__label {
    flex: 0 0 auto;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    line-height: var(--line-height-densest);
    letter-spacing: 0.02em;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .button__prefix ::slotted(*),
  .button__suffix ::slotted(*) {
    display: flex;
    height: 1.25rem;
    max-width: 1.25rem;
  }

  .button__prefix ::slotted(*) {
    margin-right: 0.6875rem;
    margin-left: -0.313rem;
  }

  .button__suffix ::slotted(*) {
    margin-right: -0.313rem;
    margin-left: 0.6875rem;
  }

  .button__prefix ::slotted(viedoc-avatar) {
    height: 1.8rem;
    max-width: 1.8rem;
    margin-left: -0.65rem;
  }

  .button__suffix ::slotted(viedoc-avatar) {
    height: 1.8rem;
    max-width: 1.8rem;
    margin-right: -0.65rem;
  }

  .button:disabled {
    pointer-events: none;
    background-color: var(--neutral-color);
    color: var(--color-gray-40);
  }

  .button__subtitle {
    font-size: var(--font-size-xs);
    opacity: 0.7;
  }

  /* -- BUTTON SIZES -- */

  .button--small {
    font-size: var(--font-size-xs);
    height: var(--button-size-small);
    padding-left: var(--button-padding-sm);
    padding-right: var(--button-padding-sm);
    min-width: 4rem;
  }

  .button--small .button__subtitle {
    font-size: var(--font-size-3xs);
  }

  .button--small .button__prefix ::slotted(*) {
    margin-right: var(--button-padding-xs);
    margin-left: -0.313rem;
  }

  .button--small .button__suffix ::slotted(*) {
    margin-right: -0.313rem;
    margin-left: var(--button-padding-xs);
  }

  .button--small .button__prefix ::slotted(viedoc-avatar) {
    height: 1.375rem;
    max-width: 1.375rem;
    margin-left: -0.5rem;
  }

  .button--small .button__suffix ::slotted(viedoc-avatar) {
    height: 1.375rem;
    max-width: 1.375rem;
    margin-right: -0.5rem;
  }

  /* -- BUTTON VARIANTS -- */

  .button--primary {
    background-color: var(--primary-color);
    color: var(--primary-contrast-color);
  }

  .button--primary:hover {
    background-color: var(--primary-highlight-color);
  }

  .button--secondary {
    background-color: var(--secondary-color);
    color: var(--secondary-contrast-color);
  }

  .button--secondary:hover {
    background-color: var(--secondary-highlight-color);
  }

  .button--neutral {
    background-color: var(--neutral-color);
    color: var(--neutral-contrast-color);
  }

  .button--neutral:hover {
    background-color: var(--neutral-highlight-color);
  }

  .button--info {
    background-color: var(--info-color);
    color: var(--info-contrast-color);
  }

  .button--info:hover {
    background-color: var(--info-highlight-color);
  }

  .button--success {
    background-color: var(--success-color);
    color: var(--success-contrast-color);
  }

  .button--success:hover {
    background-color: var(--success-highlight-color);
  }

  .button--warning {
    background-color: var(--warning-color);
    color: var(--warning-contrast-color);
  }

  .button--warning:hover {
    background-color: var(--warning-highlight-color);
  }

  .button--error {
    background-color: var(--error-color);
    color: var(--error-contrast-color);
  }

  .button--error:hover {
    background-color: var(--error-highlight-color);
  }
`;
